import React, { useState, useEffect } from 'react';

/**
 * Hook pour obtenir la position de scroll
 * Remplace react-provide-scroll-position qui n'est plus maintenu
 */
export const useScrollPosition = () => {
  const [scrollPosition, setScrollPosition] = useState({
    scrollX: window.pageXOffset,
    scrollY: window.pageYOffset
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition({
        scrollX: window.pageXOffset,
        scrollY: window.pageYOffset
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return scrollPosition;
};

/**
 * HOC pour compatibilité avec l'ancien code
 * Injecte scrollX et scrollY comme props
 */
const ProvideScrollPosition = (Component) => {
  const WrappedComponent = (props) => {
    const { scrollX, scrollY } = useScrollPosition();
    return <Component {...props} scrollX={scrollX} scrollY={scrollY} />;
  };
  
  WrappedComponent.displayName = `ProvideScrollPosition(${Component.displayName || Component.name || 'Component'})`;
  
  return WrappedComponent;
};

export const provideScrollPosition = ProvideScrollPosition;
export default provideScrollPosition;
